import _ from "lodash";

import { colors } from "theme/palette";

import Text from "components/Text";
import Tooltip from "components/Tooltip";

interface ITransactionCollapseLine {
  name: string;
  value: string | number | null;
}

const TransactionCollapseLine = ({ name, value }: ITransactionCollapseLine) => (
  <>
    <Text fontSize={16} sx={{ color: colors.gray40 }}>
      {name}
    </Text>
    <Tooltip title={!_.isNil(value) ? value : "N/A"}>
      <Text
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        maxWidth="250px"
        fontWeight={500}
        width="fit-content"
        maxHeight="fit-content"
      >
        {!_.isNil(value) ? value : "N/A"}
      </Text>
    </Tooltip>
  </>
);

export default TransactionCollapseLine;
